module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin-shop/admin-shop.component.css
// module id = ./src/app/admin/admin-shop/admin-shop.component.css
// module chunks = main